module.exports = __webpack_public_path__ + "img/italy-mental-and-behavioural-disorders-female.cc703093.png";